import { setPageIdObj, getPageIdInfo } from "../../utils/common";
import Logger from "../../utils/log";
import autoPvLister from "./auto-pv-lister";
import intClickEventLister from "./click-event-lister";
var visitOrderTracking = function visitOrderTracking() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var legoInit = arguments.length > 1 ? arguments[1] : undefined;
  // 存储pageId信息
  if (params !== null && params !== void 0 && params.routeList) {
    setPageIdObj(params.routeList);
  }

  // 初始化点击事件监听
  if (!params.disableZpmClick) {
    Logger.info('已开启点击zpmclick事件插件');
    intClickEventLister();
  }
  var pageIdInfo = getPageIdInfo(); // 当前路由命中了 routeList
  if (!pageIdInfo || !(pageIdInfo !== null && pageIdInfo !== void 0 && pageIdInfo.pageId)) return;
  if (pageIdInfo.isAutoPV === false) {
    // 存储恢复的函数
    legoInit.resumePV = function () {
      Logger.info('已开启页面zpmshow事件插件');
      autoPvLister(params, legoInit);
    };
    return;
  }
  if (!params.disableZpmShow) {
    Logger.info('已开启页面zpmshow事件插件');
    autoPvLister(params, legoInit);
  }
};
export default visitOrderTracking;